'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = undefined;
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _actionTypes = require('../constants/action-types');
var _actionTypes2 = _interopRequireDefault(_actionTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var flattenVehicle = function flattenVehicle(vehicle) {
  return Object.assign({}, vehicle, {
    model: undefined
  }, vehicle.model);
};
var defaultState = exports.defaultState = {
  view: 'regLookup',
  // oneOf(['regLookup', 'manualLookup', 'cdlOptions', 'details'])
  vehicle: {},
  // reg lookup
  cdlOptions: [],
  cdlFetching: false,
  cdlError: false,
  // manual lookup
  manualError: false,
  manualOptions: {
    manufacturerOptions: [],
    modelOptions: [],
    transOptions: [],
    fuelOptions: [],
    engineOptions: [],
    trimOptions: [],
    doorsOptions: [],
    yearOptions: []
  },
  manualFetching: {
    manufacturerOptions: false,
    modelOptions: false,
    transOptions: false,
    fuelOptions: false,
    engineOptions: false,
    trimOptions: false,
    doorsOptions: false,
    yearOptions: false
  }
};
exports.default = function (state, action) {
  switch (action.type) {
    case _actionTypes2.default.RESET_VEHICLE_LOOKUP:
      {
        return defaultState;
      }
    case _actionTypes2.default.SET_MANUAL_VIEW:
      {
        return Object.assign({}, defaultState, {
          view: 'manualLookup'
        });
      }
    case _actionTypes2.default.SELECT_VEHICLE:
      {
        return Object.assign({}, defaultState, {
          vehicle: flattenVehicle(state.cdlOptions[action.index]),
          view: 'details'
        });
      }
    case _actionTypes2.default.REG_LOOKUP + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, defaultState, {
          cdlFetching: true
        });
      }
    case _actionTypes2.default.REG_LOOKUP + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.status !== 'SUCCESS') {
          return Object.assign({}, defaultState, {
            cdlError: true
          });
        }
        if (action.payload.data.length > 1) {
          return Object.assign({}, defaultState, {
            view: 'cdlOptions',
            cdlOptions: action.payload.data
          });
        }
        return Object.assign({}, defaultState, {
          view: 'details',
          vehicle: flattenVehicle(action.payload.data[0])
        });
      }
    case _actionTypes2.default.REG_LOOKUP + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, defaultState, {
          cdlError: true
        });
      }
    case _actionTypes2.default.MANUAL_LOOKUP + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          manualFetching: Object.assign({}, defaultState.manualFetching, _defineProperty({}, action.meta.name, true))
        });
      }
    case _actionTypes2.default.CLEAR_MANUAL_LOOKUP_OPTIONS:
      {
        var options = Object.assign({}, state.manualOptions);
        action.fields.forEach(function (field) {
          options[field] = [];
        });
        return Object.assign({}, state, {
          manualOptions: Object.assign({}, options)
        });
      }
    case _actionTypes2.default.MANUAL_LOOKUP + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.vehicle || action.payload.data.abiCode) {
          return Object.assign({}, state, {
            view: 'details',
            manualFetching: defaultState.manualFetching,
            manualOptions: defaultState.manualOptions,
            vehicle: action.payload.data.vehicle || action.payload.data
          });
        }
        return Object.assign({}, state, {
          manualFetching: Object.assign({}, defaultState.manualFetching, _defineProperty({}, action.meta.name, false)),
          manualOptions: Object.assign({}, defaultState.manualOptions, state.manualOptions, action.payload.data)
        });
      }
    case _actionTypes2.default.MANUAL_LOOKUP + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          manualError: true
        });
      }
    default:
      return state;
  }
};